import React, {memo} from 'react'
import {Button, Header, Radio, Table} from 'semantic-ui-react'
import {withErrorHandling, withHelmet, withPropsPresent, withServiceData} from '../../../hoc'
import {cloneVersion, publishVersion} from '../../../backend'
import {coerceToISODate, getPublishedOrFirstVersion, toLocaleDateString} from '../../../util'
import {useSafeState} from '../../../hook'

const _ManageVersions = (props) => {
  let {
    service,
    navigate,
    publishVersion,
    cloneVersion,
    mutateService,
    basePath = '/c/services/:serviceId/versions',
    children
  } = props

  const [state, setState] = useSafeState({
    publishing: '',
    published: getPublishedOrFirstVersion(service, {}).id,
    cloning: ''
  })

  const getPathPrefix = () => {
    return basePath
      .replace(':serviceId', service.id)
  }

  const onDone = (e) => {
    e.preventDefault()
    navigate(getPathPrefix())
  }

  const onAdd = (e) => {
    e.preventDefault()
    navigate(`add`)
  }

  const onEdit = (e, version) => {
    e.preventDefault()
    navigate(`${version.id}/edit`)
  }

  const onRemove = (e, version) => {
    e.preventDefault()
    navigate(`${version.id}/remove`)
  }

  const onPublish = async (e, version) => {
    e.preventDefault()
    setState({...state, publishing: version.id})
    await publishVersion(service.id, version.id)
    setState({...state, publishing: '', published: version.id})
    mutateService()
  }

  const onCloneVersion = async (e, version) => {
    e.preventDefault()
    setState({...state, cloning: version.id})
    await cloneVersion(version.id)
    setState({...state, cloning: ''})
    mutateService()
  }

  const onArchiveVersion = (e, version) => {
    e.preventDefault()
    navigate(`${getPathPrefix()}/manage/${version.id}/archive`)
  }

  return (
    <div>
      <div style={{clear: 'both'}}></div>
      {
        !!service.versions.length && (
          <>
            <Header as="h4" dividing>Manage Versions</Header>
            <Table celled data-testid="versions-table">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width="3">Name</Table.HeaderCell>
                  <Table.HeaderCell width="1">Published</Table.HeaderCell>
                  <Table.HeaderCell width="1">Last Accessed</Table.HeaderCell>
                  <Table.HeaderCell width="3">Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  service.versions.map((version) => (
                    <Table.Row key={version.id} data-test="versions-table-row">
                      <Table.Cell className="version-name" data-test="version-name">{version.name}</Table.Cell>
                      <Table.Cell>
                        {
                          state.publishing === version.id && (
                            <Button size="mini" loading={true}/>
                          )
                        }
                        {
                          state.publishing !== version.id && (
                            <Radio toggle disabled={state.published === version.id}
                                   checked={state.published === version.id}
                                   data-test="version-published"
                                   onChange={(e) => onPublish(e, version)}/>
                          )
                        }
                      </Table.Cell>
                      <Table.Cell className="version-name"
                                  data-test="version-name">{version.lastAccessedAt ? toLocaleDateString(coerceToISODate(version.lastAccessedAt)) : 'n/a'}</Table.Cell>
                      <Table.Cell>
                        <div style={{float: 'left'}}>
                          <Button basic size="tiny"
                                  title="edit"
                                  icon="edit"
                                  onClick={(e) => onEdit(e, version)}
                                  data-test="version-edit-action"
                                  style={{marginRight: '10px'}}>
                          </Button>
                          <Button basic size="tiny"
                                  title="clone"
                                  icon="copy"
                                  onClick={async (e) => await onCloneVersion(e, version)}
                                  loading={state.cloning === version.id}
                                  data-test="version-clone-action"
                                  style={{marginRight: '10px'}}>
                          </Button>
                          <Button basic size="tiny"
                                  title="remove"
                                  icon="remove circle"
                                  onClick={(e) => onRemove(e, version)}
                                  data-test="version-remove-action"
                                  style={{marginRight: '10px'}}>
                          </Button>
                          <Button basic size="tiny"
                                  icon="archive"
                                  title="archive"
                                  onClick={(e) => onArchiveVersion(e, version)}
                                  data-test="version-archive-action">
                          </Button>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
            </Table>
          </>
        )
      }
      {
        !service.versions.length && (<div>No versions found</div>)
      }
      {
        !!service.versions.length && (
          <Button size="tiny"
                  basic
                  icon="cancel"
                  content="Done"
                  data-testid="manage-versions-done-button"
                  style={{marginTop: '25px'}}
                  onClick={onDone}/>
        )
      }
      <Button size="tiny"
              basic
              primary
              icon="add"
              data-testid="manage-versions-add-button"
              content="Add Version"
              style={{marginTop: '25px'}}
              onClick={(e) => onAdd(e)}/>
      {children}
    </div>
  )
}

let ManageVersions = (props) => {
  const {handleError} = props
  props = {
    ...props,
    cloneVersion: handleError(cloneVersion),
    publishVersion: handleError(publishVersion)
  }
  return (<_ManageVersions {...props}/>)
}

ManageVersions = withPropsPresent(ManageVersions, ['service'])
ManageVersions = withHelmet(ManageVersions, 'Manage Versions')
ManageVersions = withServiceData(ManageVersions, 'Loading service...')
ManageVersions = withErrorHandling(ManageVersions)
ManageVersions = memo(ManageVersions)

export {_ManageVersions, ManageVersions}

export default ManageVersions